import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    selector: 'app-transmission-status-cell-renderer',
    imports: [CommonModule],
    template: `
    <div class="transmission-status-container">
      <span 
        class="status-circle" 
        [ngClass]="getStatusClass()"
        [title]="getStatusLabel()">
      </span>
      <span class="status-text"></span>
    </div>
  `,
    styles: [`
    .transmission-status-container {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 100%;
    }

    .status-circle {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      border: 2px solid;
      flex-shrink: 0;
    }

    .status-text {
      font-size: 13px;
      line-height: 1;
    }

    /* Status-specific styles */
    .status-success {
      background-color: #4caf50;
      border-color: #4caf50;
    }

    .status-pending {
      background-color: transparent;
      border-color: #ff9800;
    }

    .status-waiting {
      background-color: transparent;
      border-color: #9e9e9e;
    }

    .status-error {
      background-color: #f44336;
      border-color: #f44336;
    }

    .status-processing {
      background-color: transparent;
      border-color: #2196f3;
    }

    .status-completed {
      background-color: #4caf50;
      border-color: #4caf50;
    }

    .status-failed {
      background-color: #f44336;
      border-color: #f44336;
    }

    .status-default {
      background-color: transparent;
      border-color: #ccc;
    }
  `]
})
export class TransmissionStatusCellRendererComponent implements ICellRendererAngularComp {
  statusText: string | number = '';

  private statusCodeMap: { [key: number]: string } = {
    0: 'waiting',
    1: 'success',
    2: 'failed'
  };

  agInit(params: ICellRendererParams): void {
  this.statusText = params.value ?? '';
  }

  refresh(params: ICellRendererParams): boolean {
    this.statusText = params.value ?? '';
    return true;
  }
    getStatusClass(): string {
    let statusText: string;
    if (typeof this.statusText === 'number') {
      statusText = this.statusCodeMap[this.statusText] || 'Waiting';
    } else {
      statusText = this.statusText || 'Waiting';
    }

    return `status-${statusText.toLowerCase()}`;
  }

  getStatusLabel(): string {
    if (typeof this.statusText === 'number') {
      const label = this.statusCodeMap[this.statusText];
      return label ? label.charAt(0).toUpperCase() + label.slice(1) : String(this.statusText);
    }
    return String(this.statusText) || 'Waiting';
  }
}